<template>
    <div class="prewrap">
        <!-- {{  j }} -->
        <ReNoteJsonItem :items="rows" />
    </div>
</template>

<script>
import ReNoteJsonItem from './ReNoteJsonItem.vue';
// import ReNoteJsonValue from './ReNoteJsonValue.vue';

export default {
    name: 'ReNoteJson',
    props: {
        data: String
    },
    computed: {
        rows() {
            try {
                const j = JSON.parse(this.data);
                return j;
            } catch (e) {
                return {'Ошибка разбора': this.data};
            }
        }
    },
    components: {
        ReNoteJsonItem,
        // ReNoteJsonValue
    }
}
</script>
